import { render, staticRenderFns } from "./pi-my-user-info.vue?vue&type=template&id=ed08c166&scoped=true&"
import script from "./pi-my-user-info.vue?vue&type=script&lang=js&"
export * from "./pi-my-user-info.vue?vue&type=script&lang=js&"
import style0 from "./pi-my-user-info.vue?vue&type=style&index=0&id=ed08c166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed08c166",
  null
  
)

export default component.exports